/** @jsx jsx */
import { jsx } from 'theme-ui';
import Box from '../Grid/Box';

const tags = {
  semiTitle: 'h3',
  default: 'div',
};

const nowrapStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export default function Text({
  variant = 'default',
  as = tags[variant] || tags.default,
  variants = 'text',
  lowContrast = false,
  nowrap = false,
  children,
  ...rest
}) {
  return (
    <Box
      as={as}
      {...rest}
      sx={{
        variant: `${variants}.${variant}`,
        fontWeight: lowContrast ? 'lowContrast' : undefined,
        ...(nowrap && nowrapStyle),
      }}
    >
      {children}
    </Box>
  );
}
